import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=220b811b&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=220b811b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b811b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('220b811b')) {
      api.createRecord('220b811b', component.options)
    } else {
      api.reload('220b811b', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=220b811b&scoped=true", function () {
      api.rerender('220b811b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/sifde/Main.vue"
export default component.exports